<div class="column card has-round-border" style="margin-bottom: 2%; margin-top: 2%">
  <div class="columns" style="background-color: #35566E">
    <div class="column">
      <div class="title is-4 has-text-centered is-bold" style="color: white !important">
        Dokumentübersicht: Letzte Bestellungen
      </div>
    </div>
  </div>


  <div class="columns" style="flex-wrap: wrap">
    <div *ngFor="let key of keys ; let i = index;" class="column" [ngClass]="{'is-one-third':i >= 6, 'is-12': i < 6}">
      <div class="card has-text-centered title is-5 is-darkblue has-round-border mb-5" style="padding: 0.5rem;z-index: 1;font-weight: bold">{{key}}</div>
      <div class="card products-card">
        <div class="columns" style="flex-wrap: wrap">
          <div class="column is-product is-one-third has-text-centered has-round-border" style="align-items: center;display: inline-grid" *ngFor="let product of productsByCategory[key]">
            <div *ngIf="isLoadingEntryDates">
              <p class="is-bold">{{product.name_show}}:</p>
              <ngx-skeleton-loader  count="1" appearance="line" animation="progress" [theme]="{'animation':'none','margin':'2px auto','width':'35%'}"></ngx-skeleton-loader>
            </div>
            <div *ngIf="documentEntryDate.get(savedPropertyId) && documentEntryDate.get(savedPropertyId)[product.nameShort]">
              <span>
                <p class="is-bold">{{product.name_show}}:</p>
                <!--if the date is older then 6 weeks the date will be yellow. If the date is older then 12 months the date will be red-->
                <p [ngClass]="{'yellow': documentEntryDate.get(savedPropertyId)[product.nameShort] + 3628800000 <= today.getTime(),
                 'red': documentEntryDate.get(savedPropertyId)[product.nameShort] + 31556926000 <= today.getTime()}" style="color: green"> {{documentEntryDate.get(savedPropertyId)[product.nameShort] | date:'dd.MM.yyyy'}}</p>
              </span>
            </div>
            <div *ngIf="documentEntryDate.size > 0 && !documentEntryDate.get(savedPropertyId)[product.nameShort] || !isLoadingEntryDates && documentEntryDate.size === 0">
              <span>
                <p class="is-bold">{{product.name_show}}:</p>
                <p style="color: #f14668">nicht bestellt</p>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-12 has-text-right" style="padding-bottom: 5px;padding-right: 0">
        </div>
      </div>
    </div>
  </div>
</div>
